/**
 * Conflict detection — T-1.3.4.
 *
 * Pure function: "is `coord` already in the voxels Map?". The Map is the
 * scene's single source of truth for placed voxels (Constitution §2.2 /
 * SPEC §2.1), so `voxels.has(coord)` is the only correct answer.
 *
 * Why a separate function and not inline `voxels.has(coord)` in MainCanvas?
 *   1. The drop handler in MainCanvas is the first of many callers — T-1.3.5
 *      PlaceVoxel.apply() will ask the same question before mutating the
 *      store, and the command layer must be unit-testable in isolation.
 *   2. The contract ("VoxelCoord tuple key, not string") is easy to break
 *      with a careless refactor; a single chokepoint with its own tests
 *      pins the invariant (see tests/unit/conflict-detection.test.ts).
 *   3. read-only by construction — does NOT take or hold any store ref,
 *      so render-layer discipline (no MainScene ref) is preserved.
 *
 * Visual feedback (red vs. blue ghost) lives in GhostPreview.showConflict,
 * not here. This function only answers the data-plane question.
 */

import type { VoxelCoord, VoxelProps } from '@/state/types';

export function checkConflict(coord: VoxelCoord, voxels: Map<VoxelCoord, VoxelProps>): boolean {
  return voxels.has(coord);
}
